import { useSyncExternalStore } from 'react';
import { getConsent, subscribe, type ConsentState } from './consent';

/** A escolha de cookies vigente, re-renderizando a cada mudança. */
export function useConsent(): ConsentState {
  return useSyncExternalStore(subscribe, getConsent, getConsent);
}
